import { render, staticRenderFns } from "./MonthPostingList.vue?vue&type=template&id=c283aed0&scoped=true&"
import script from "./MonthPostingList.vue?vue&type=script&lang=js&"
export * from "./MonthPostingList.vue?vue&type=script&lang=js&"
import style0 from "./MonthPostingList.vue?vue&type=style&index=0&id=c283aed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c283aed0",
  null
  
)

export default component.exports